import React, { useRef, useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import Dropdown from 'antd/es/dropdown/dropdown';
import { ReactComponent as ArrowDropDownIcon } from "../../assets/images/dropdown-arrow.svg";
function SelectInputTeam(props) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [data, setData] = useState([]);
  const [selectedOption, setSelectedOption] = useState('Select role');

  const dispatch = useDispatch();
  const buttonRef = useRef(null);
  const open = Boolean(anchorEl);

  const userData = useSelector((state) => state.loginToken);
  const uRole = userData.response?.user?.role_name;

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (option) => {
    setSelectedOption(option);
    handleClose();
    props.onChange(option);
  };

  useEffect(() => {
    const roles = [
      // 'supervisor',
      'agent',
      'admin'
    ];

    const filteredRoles = (uRole === 'admin_with_billing' || uRole === 'admin') ? roles : ['agent'];

    const outputArray = filteredRoles.map((role, index) => ({
      id: index,
      title: role
    }));

    setData(outputArray);
  }, []);

  const {
    name = 'name',
    id = 'id',
    onChange = () => { },
    value,

  } = props;
  return (
    <div style={{ width: '100%' }}>
      <Button
        aria-label="more"
        id="long-button"
        aria-controls={open ? 'long-menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        name={name}
        value={value}
        onChange={onChange}
        aria-haspopup="true"
        onClick={handleClick}
        disableRipple={true}
        disableFocusRipple={true}
        disableElevation={true}
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          color: '#1e1e1e',
          backgroundColor: '#ffffff',
          border: '1px solid #c4c4c4 !important',
          fontSize: '12px',
          fontWeight: '500',
          borderRadius: '8px',
          padding: '12px',
          width: '100%',
          textTransform: 'capitalize',
          marginTop: '8px',
          height: '40px',
          position: 'relative',
          boxShadow: 'none !important',
          // Override ALL possible border states
          '&:hover': {
            backgroundColor: '#f8f9fa',
            border: '1px solid #c4c4c4 !important',
            boxShadow: 'none !important',
          },
          '&:focus': {
            backgroundColor: '#ffffff',
            border: '1px solid #c4c4c4 !important',
            boxShadow: 'none !important',
            outline: 'none !important',
          },
          '&:active': {
            backgroundColor: '#f0f0f0',
            border: '1px solid #c4c4c4 !important',
            boxShadow: 'none !important',
          },
          '&.Mui-focusVisible': {
            backgroundColor: '#ffffff',
            border: '1px solid #c4c4c4 !important',
            boxShadow: 'none !important',
            outline: 'none !important',
          },
          '&.MuiButton-root': {
            border: '1px solid #c4c4c4 !important',
          },
          '&.MuiButton-outlined': {
            border: '1px solid #c4c4c4 !important',
          },
          '&.MuiButton-outlined:hover': {
            border: '1px solid #c4c4c4 !important',
          },
          '&.MuiButton-outlined:focus': {
            border: '1px solid #c4c4c4 !important',
          },
          // Remove ripple effects completely
          '& .MuiTouchRipple-root': {
            display: 'none !important',
          },
          // Remove any focus rings
          '&:focus-visible': {
            outline: 'none !important',
            border: '1px solid #c4c4c4 !important',
          },
          // Remove button focus outline
          '&.MuiButtonBase-root:focus': {
            outline: 'none !important',
            border: '1px solid #c4c4c4 !important',
          }
        }}
        ref={buttonRef}
      >
        <span style={{
          flex: 1,
          textAlign: 'left',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis'
        }}>
          {selectedOption}
        </span>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginLeft: '8px',
          flexShrink: 0,
          width: '16px',
          height: '16px',
        }}>
          <ArrowDropDownIcon


          />
        </div>
      </Button>
      <Menu
        id="long-menu"
        MenuListProps={{
          'aria-labelledby': 'long-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          sx: {
            width: open && buttonRef.current ? buttonRef.current.offsetWidth : 'auto',
            textTransform: 'capitalize',
            marginTop: '4px',
            padding: '8px',
          },
        }}
      >
        {data.map((option) => (
          <MenuItem
            key={option.id}
            selected={option.title === selectedOption}
            onClick={() => handleMenuItemClick(option.title)}
            className="Select-number"
            sx={{
              fontSize: '14px',
              color: '#556575',
              fontFamily: 'Inter',
              padding: '8px 8px',
              fontWeight: '400',
              textTransform: 'capitalize',
              borderRadius: '8px', // always rounded
              '&:hover': {
                background: '#F9FAFA', // hover style
                borderRadius: '8px',
                color: '#061522'
              },
              '&.Mui-selected': {
                background: '#F9FAFA', // selected style
                borderRadius: '8px',
                color: '#061522'
              },
              '&.Mui-selected:hover': {
                background: '#F9FAFA', // keep same when hovered + selected
                borderRadius: '8px',
                color: '#061522'
              },
            }}
          >
            {option.title}
          </MenuItem>
        ))}
      </Menu>

    </div>
  );

}

export default SelectInputTeam;
